import * as t from 'io-ts';
import { id, meta, score } from '@/services/api';
import { DateFromUnixTime } from 'io-ts-types/DateFromUnixTime';
import { recordCodec } from '@/services/api/resources/issue/v2';

//legacy endpoint - anything can be null

const structuredResponseCodec = t.type({
  uuid: t.union([t.string, t.null]),
  color: t.union([t.string, t.null]),
  score: t.union([score, t.undefined]),
  title: t.union([t.string, t.null]),
  negative: t.union([t.boolean, t.null]),
});

export const questionCodec = t.type({
  id: t.number,
  uuid: t.string,
  title: t.union([t.string, t.null]),
  inspectionTitle: t.union([t.string, t.undefined, t.null]),
  response: t.union([t.string, t.null]),
  structuredResponse: t.union([t.array(structuredResponseCodec), t.null]),
  checklistTitle: t.union([t.string, t.null]),
  conductedAt: t.union([DateFromUnixTime, t.null]),
  conductedBy: t.union([t.string, t.null]),
  inspectionId: t.union([t.null, id]),
  score,
  entityItem: t.union([t.string, t.null]),
  issues: t.union([t.null, t.array(recordCodec)]),
});

export const questionListCodec = t.type({
  data: t.array(questionCodec),
  meta,
});
